import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";

// MUI Components
import Typography from "@material-ui/core/Typography";
import WarningIcon from "@material-ui/icons/Warning";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

// Icons
import AssignmentIcon from "@material-ui/icons/Assignment";
import TimeIcon from "@material-ui/icons/AccessTime";
import UserIcon from "@material-ui/icons/AssignmentInd";
import HealingIcon from "@material-ui/icons/Healing";

// Other
import Notes from "./Notes.js";
import { customTheme } from "../../constants/customTheme.js";

const useStyles = makeStyles({
  root: {
    flex: "1 1 auto",
    height: "100%",
  },
  studyInfo: {
    height: "100%",
    padding: "13px 20px 50px 20px",
    overflowY: "auto",
    ...customTheme().customScrollBar,
  },
  listRoot: {
    display: "flex",
    flexDirection: "column",
  },
  headerSpace: {
    height: "35px",
  },
  listItem: {
    padding: "5px",
  },
  listItemNote: {
    padding: "25px 5px 5px 5px",
  },
  listTitle: {
    fontWeight: 600,
    fontSize: "1.5rem",
    textAlign: "center",
  },
  listIcon: {
    paddingRight: "15px",
    minWidth: "unset",
  },
  listText: {
    "& span": {
      fontSize: "1rem",
    },
    "& p": {
      fontSize: "1rem",
    },
  },
  icon: customTheme().iconMedium,
});

const StudyInfoSection = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.headerSpace} />
      <div className={classes.studyInfo}>
        <Typography
          variant="h4"
          gutterBottom={true}
          className={classes.listTitle}
          color="textPrimary"
        >
          Study Information
        </Typography>
        <List disablePadding className={classes.listRoot}>
          <ListItem className={classes.listItem}>
            <ListItemIcon className={classes.listIcon}>
              <UserIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              className={classes.listText}
              primary="Participant Information"
              secondary={
                <span>
                  Participant ID: {props.participantId}
                  <br />
                  Birth Year: {props.birthYear === "" ? "-" : props.birthYear}
                  <br />
                  Skin Type: {props.skinType === "" ? "-" : props.skinType}
                  <br />
                  Gender: {props.gender === "" ? "-" : props.gender}
                  <br />
                  Other ID: {props.otherId === "" ? "-" : props.otherId}
                </span>
              }
            />
          </ListItem>

          <ListItem className={classes.listItem}>
            <ListItemIcon className={classes.listIcon}>
              <AssignmentIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              className={classes.listText}
              primary="Protocol Name"
              secondary={props.protocolName}
            />
          </ListItem>

          <ListItem className={classes.listItem}>
            <ListItemIcon className={classes.listIcon}>
              <TimeIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText
              className={classes.listText}
              primary="Started On"
              secondary={props.startedAt}
            />
          </ListItem>

          <ListItem className={classes.listItem}>
            <ListItemIcon className={classes.listIcon}>
              <HealingIcon className={classes.icon} color={"inherit"} />
            </ListItemIcon>
            <ListItemText
              className={classes.listText}
              primary="Device Health"
              secondary={
                props.connectionEstablished
                  ? props.simulate
                    ? "Diagnostics not run on simulate mode"
                    : props.deviceHealth.message
                  : "Connect to device to run diagnostics"
              }
            ></ListItemText>
          </ListItem>

          {props.locked && (
            <ListItem className={classes.listItem}>
              <ListItemIcon className={classes.listIcon}>
                <WarningIcon className={classes.icon} />
              </ListItemIcon>
              <ListItemText
                className={classes.listText}
                primary="Study Locked"
                secondary={
                  "This study is locked. No new acquisitions can be added."
                }
              ></ListItemText>
            </ListItem>
          )}
          <ListItem className={classes.listItemNote}>
            <ListItemText
              className={classes.listText}
              primary={<Notes prompt="STUDY" />}
            />
          </ListItem>
        </List>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    locked: state.studyInfo.locked,
    participantId: state.studyInfo.participantId,
    protocolName: state.studyInfo.protocolName,
    startedAt: state.studyInfo.startedAt,
    birthYear: state.studyInfo.birthYear,
    skinType: state.studyInfo.skinType,
    gender: state.studyInfo.gender,
    otherId: state.studyInfo.otherId,
    deviceHealth: state.device.health,
    simulate: state.device.simulate,
    connectionEstablished: state.device.connectionEstablished,
  };
};

export default connect(mapStateToProps)(StudyInfoSection);
